import type React from "react";
import { GiTwoCoins } from "react-icons/gi";
import styles from "./Scores.module.scss";

type Props = {
	score: number;
};
const Scores: React.FC<Props> = ({ score }) => {
	return (
		<div className={styles.scoresContainer}>
			<div className={styles.scoresHeader}>
				<div className={styles.scoresContent}>
					<GiTwoCoins />
					<h2>Scores</h2>
				</div>
				<p>{score}</p>
			</div>
		</div>
	);
};

export default Scores;
